export const VECTORIZED_IMAGE_IDENTIFIER = 'vs-generated-outline';

export function isVectorizedImage(svgText: string) {
  const regex = new RegExp(`<g[^>]*id=["']${VECTORIZED_IMAGE_IDENTIFIER}["'][^>]*>`);
  return regex.test(svgText);
}
